import { ScorecardRichText } from '@/components/scorecard/ScorecardRichText';

export type MandateCategoryRating = {
  category?: string;
  category_key?: string;
  user_mandate?: string;
  result?: string;
  feedback?: string;
  points?: number | null;
};

export type MandateStructured = {
  mandate_score?: number | null;
  category_ratings?: MandateCategoryRating[];
  overall_feedback?: string;
};

type MandateSectionProps = {
  structured?: MandateStructured | null;
};

function pct(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return 'Not Applicable';
  return `${Math.round(v)}%`;
}

export function MandateSection({ structured }: MandateSectionProps) {
  const ratings = structured?.category_ratings?.filter((r) => r.result !== 'Not Applicable') ?? [];
  if (!structured?.overall_feedback && ratings.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4 mb-6">
      <p className="text-sm font-semibold text-white">
        Mandate Score = {pct(structured?.mandate_score ?? null)}
      </p>
      {structured?.overall_feedback?.trim() ? (
        <ScorecardRichText text={structured.overall_feedback} />
      ) : null}
      {ratings.length > 0 ? (
        <div className="space-y-4 mt-4">
          <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/45">
            Detailed User Feedback
          </p>
          {ratings.map((r, i) => (
            <div key={r.category_key ?? r.category ?? i} className="text-sm text-white/80 border-l-2 border-white/10 pl-3">
              <p className="font-medium text-white/90">{r.category}</p>
              <p className="text-white/60 text-xs mt-1">User Mandate: {r.user_mandate ?? '—'}</p>
              <p className="text-white/60 text-xs">Result: {r.result ?? '—'}</p>
              {r.feedback?.trim() ? (
                <div className="mt-2">
                  <ScorecardRichText text={r.feedback} className="space-y-2" />
                </div>
              ) : (
                <p className="mt-2 text-white/85">—</p>
              )}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default MandateSection;
